export const heroData = {
  title: "找到属于你的社群归属感",
  subtitle: "男同网 — 安全、私密、友好的男同交友社区。在这里，你可以做真实的自己，结识志同道合的朋友。",
  ctaText: "立即加入",
  ctaLink: "#join",
  secondaryCtaText: "了解更多",
  secondaryCtaLink: "#features",
  backgroundImage: "https://readdy.ai/api/search-image?query=Warm%20abstract%20atmospheric%20composition%20with%20soft%20layered%20gradients%20in%20warm%20coral%20and%20terracotta%20tones%2C%20dreamy%20fluid%20shapes%20with%20gentle%20light%20rays%2C%20modern%20minimalist%20design%2C%20elegant%20and%20inclusive%20atmosphere%2C%20soft%20focus%20background%20with%20subtle%20texture%2C%20warm%20ambient%20mood%2C%20artistic%20abstract%20wallpaper%20for%20community%20platform%20hero%20section%2C%20no%20text%20no%20people&width=1800&height=1000&seq=hero-bg-2026&orientation=landscape"
};

export const featureItems = [
  {
    icon: "ri-shield-check-line",
    title: "安全私密",
    description: "严格的身份验证机制和隐私保护策略，确保每位用户的个人信息和聊天内容得到充分保护。"
  },
  {
    icon: "ri-heart-pulse-line",
    title: "真实连接",
    description: "基于兴趣和价值观的智能匹配算法，帮助你找到真正合拍的朋友，建立有意义的社交关系。"
  },
  {
    icon: "ri-group-line",
    title: "活跃社群",
    description: "数万活跃用户，每日更新的话题讨论、线上线下活动，让社交不再局限于屏幕。"
  },
  {
    icon: "ri-chat-smile-2-line",
    title: "自由表达",
    description: "在包容友好的环境中畅所欲言，分享你的故事、爱好和生活点滴，找到真正的归属感。"
  },
  {
    icon: "ri-calendar-event-line",
    title: "丰富活动",
    description: "定期举办线上话题讨论和线下聚会活动，覆盖全国多个城市，拓展你的社交圈。"
  },
  {
    icon: "ri-medal-line",
    title: "品质保障",
    description: "专业的社区运营团队全年无休维护平台秩序，打造高品质、有温度的社交环境。"
  }
];

export const statsData = [
  { number: "50,000+", label: "注册用户" },
  { number: "300+", label: "城市覆盖" },
  { number: "98.6%", label: "用户满意度" },
  { number: "1,200+", label: "月度活动" }
];

export const faqData = [
  {
    question: "男同网如何保障用户隐私安全？",
    answer: "我们采用端到端加密技术保护聊天内容，支持匿名注册和隐私模式浏览。用户个人信息仅用于平台服务，绝不会出售或泄露给第三方。所有数据传输均通过HTTPS加密，数据库访问采用严格的权限管控。"
  },
  {
    question: "注册男同网需要提供哪些信息？",
    answer: "最低只需一个有效的邮箱地址即可注册。你可以选择填写更多个人资料来获得更好的匹配体验，但这不是强制性的。我们尊重每位用户的隐私需求。"
  },
  {
    question: "如何确保平台上用户身份的真实性？",
    answer: "我们采用多重验证机制，包括邮箱验证、手机验证以及可选的身份认证。同时，社区举报机制和人工审核团队7×24小时巡查，确保平台环境的真实与安全。"
  },
  {
    question: "男同网支持哪些形式的交流？",
    answer: "平台支持文字聊天、语音通话、视频通话等多种交流方式。你还可以加入兴趣群组、参与话题讨论、发布个人动态，以及参加线上线下的社区活动。"
  },
  {
    question: "平台是否收费？",
    answer: "男同网基础功能完全免费，包括注册、浏览、匹配、聊天等核心功能。我们也提供会员增值服务，包括高级匹配算法、更多展示机会等可选功能。"
  },
  {
    question: "如何举报不当行为或骚扰？",
    answer: "在用户主页、聊天窗口或个人动态页面均设有举报按钮。点击后选择举报原因并提交，我们的审核团队会在2小时内处理。你还可以将用户加入黑名单，立即终止一切互动。"
  }
];

export const articleCategories = [
  { slug: "dating-tips", name: "交友技巧", icon: "ri-heart-3-line" },
  { slug: "life-share", name: "生活分享", icon: "ri-sun-line" },
  { slug: "community-events", name: "社区活动", icon: "ri-calendar-check-line" },
  { slug: "self-growth", name: "自我成长", icon: "ri-seedling-line" },
  { slug: "health-wellness", name: "健康养生", icon: "ri-mental-health-line" },
  { slug: "culture-entertainment", name: "文化娱乐", icon: "ri-movie-2-line" }
];

export const featuredArticles = [
  {
    id: 1,
    title: "如何在交友平台上展现真实的自己",
    excerpt: "展示真实的自己，是建立真诚关系的第一步。本文分享如何在交友平台上自然展现个性，同时保持必要的隐私保护。",
    category: "dating-tips",
    categoryName: "交友技巧",
    author: "小雨",
    date: "2026-08-08",
    readTime: "8分钟",
    image: "https://readdy.ai/api/search-image?query=Warm%20minimalist%20desk%20scene%20with%20laptop%20and%20notebook%2C%20soft%20natural%20lighting%2C%20cozy%20modern%20interior%20with%20indoor%20plants%2C%20editorial%20lifestyle%20photography%2C%20calm%20and%20introspective%20mood%2C%20gentle%20beige%20and%20cream%20tones%2C%20clean%20composition%20without%20people&width=800&height=500&seq=article-feat-1&orientation=landscape"
  },
  {
    id: 2,
    title: "2026年同志骄傲月活动全攻略",
    excerpt: "一年一度的骄傲月即将到来，全国各大城市将举办丰富多彩的庆祝活动。这份攻略带你了解各地活动安排与参与方式。",
    category: "community-events",
    categoryName: "社区活动",
    author: "阿杰",
    date: "2026-08-05",
    readTime: "12分钟",
    image: "https://readdy.ai/api/search-image?query=Colorful%20festival%20atmosphere%20with%20warm%20decorative%20lights%20and%20celebration%20elements%2C%20soft%20evening%20ambient%20lighting%2C%20vibrant%20yet%20elegant%20party%20scene%2C%20artistic%20photography%20with%20shallow%20depth%20of%20field%2C%20warm%20golden%20and%20rose%20tones%2C%20no%20people%20visible&width=800&height=500&seq=article-feat-2&orientation=landscape"
  },
  {
    id: 3,
    title: "出柜后的心理调适：过来人的经验分享",
    excerpt: "出柜是重要的人生决定，之后的心理调适同样关键。多位过来人分享他们的心路历程和实用建议。",
    category: "self-growth",
    categoryName: "自我成长",
    author: "浩然",
    date: "2026-08-02",
    readTime: "10分钟",
    image: "https://readdy.ai/api/search-image?query=Serene%20sunrise%20over%20calm%20ocean%20horizon%2C%20soft%20pastel%20sky%20colors%20with%20gentle%20clouds%2C%20peaceful%20and%20hopeful%20atmosphere%2C%20minimalist%20nature%20photography%2C%20warm%20golden%20light%20breaking%20through%2C%20symbolizing%20new%20beginnings%2C%20no%20people&width=800&height=500&seq=article-feat-3&orientation=landscape"
  }
];